import React, { useState } from 'react';

// إضافة قيمة افتراضية إذا لم يتم تمرير language
function ContactForm({ language = 'en' }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // طريقة بديلة بسيطة لعرض البيانات
    console.log('Form Data:', formData);
    console.log('Language:', language);
    
    setTimeout(() => {
      alert(language === 'ar' ? 'تم حفظ طلبك، سنتواصل معك قريباً!' : 'Your request has been saved, we will contact you soon!');
      setFormData({ name: '', email: '', phone: '', message: '' });
      setIsSubmitting(false);
    }, 1000);
  };

  return (
    <>
      <section className="project-section">
        <h2 className="project-title">
          {language === 'ar' ? 'ابدأ مشروعك الجديد' : 'START YOUR NEW PROJECT'}
        </h2>

        <form className="project-form" onSubmit={handleSubmit}>
          <input
            id="name"
            type="text"
            placeholder={language === 'ar' ? 'اسمك' : 'YOUR NAME'}
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            id="email"
            type="email"
            placeholder={language === 'ar' ? 'بريدك الإلكتروني' : 'YOUR EMAIL'}
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            id="phone"
            type="text"
            placeholder={language === 'ar' ? 'رقم هاتفك' : 'YOUR PHONE'}
            value={formData.phone}
            onChange={handleChange}
            required
          />
          <textarea
            id="message"
            placeholder={language === 'ar' ? 'رسالتك' : 'Message'}
            value={formData.message}
            onChange={handleChange}
            rows={4}
          />

          <button type="submit" disabled={isSubmitting}>
            {isSubmitting 
              ? (language === 'ar' ? 'جاري الإرسال...' : 'Sending...')
              : (language === 'ar' ? 'إرسال الطلب' : 'SEND REQUEST')
            }
          </button>
        </form>

        {/* <p className="project-text">
          {language === 'ar' 
            ? 'هل أنت مستعد لتحويل رؤيتك التجارية إلى واقع؟ تواصل مع مؤسسة الجبرية اليوم للحصول على استشارة مجانية. فريقنا الخبير مستعد لمرافقتك في كل خطوة من خطوات مشروعك، مستفيدًا من خبرة تتجاوز 30 عامًا لضمان نجاحك في السوق السعودي.'
            : 'Ready to transform your business vision into reality? Contact Al-Jabriyah Establishment today for a complimentary consultation. Our expert team is prepared to guide you through every step of your project, leveraging our 30+ years of experience to ensure your success in the Saudi market.'
          }
        </p> */}
      </section>

      <section className="contacts-section" id="contact">
        <h2 className="contacts-title">
          {language === 'ar' ? 'بيانات ' : 'OUR '}
          <span>{language === 'ar' ? 'التواصل' : 'CONTACTS'}</span>
        </h2>

        <div className="contact-info">
          <div className="ci-item">
            <img 
              src="data:image/svg+xml;utf8,<svg fill='purple' width='24' height='24' xmlns='http://www.w3.org/2000/svg'><path d='M12 2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5S10.6 6.5 12 6.5s2.5 1.1 2.5 2.5S13.4 11.5 12 11.5z'/></svg>" 
              className="icon" 
              alt="Location"
            />
            <p>
              {language === 'ar' 
                ? 'المملكة العربية السعودية | مكتب الرياض، ضميت الجديدة'
                : 'KSA | Riyadh Office Dimyat Al Jadidah'
              }
            </p>
          </div>

          <div className="ci-item">
            <img 
              src="data:image/svg+xml;utf8,<svg fill='purple' width='24' height='24' xmlns='http://www.w3.org/2000/svg'><path d='M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z'/></svg>" 
              className="icon" 
              alt="Email"
            />
            <p>info@al-Jabriyah.com</p>
          </div>
        </div>

        <div className="contacts-map">
          <div className="map-wrapper">
            <img 
              src="https://upload.wikimedia.org/wikipedia/commons/8/80/World_map_-_low_resolution.svg" 
              className="map-img" 
              alt="World Map"
            />
            <a 
              href="https://maps.app.goo.gl/tad2yNG1wkn3URkh7" 
              className="pin" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="Location on Google Maps"
            >
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default ContactForm;